import request from './request';

export interface PriceOffset {
  id: number;
  productCode: string;
  offsetValue: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  userId: number;
}

/**
 * 价格偏移记录及关联点数据统计
 */
export interface PriceOffsetWithPointCount {
  priceOffset: PriceOffset;
  pointCount: number;
}

/**
 * 获取所有激活的价格偏移
 */
export const fetchActiveOffsets = (): Promise<PriceOffset[]> => {
  return request.get('/market/api/v1/admin/market/price/offset');
};

/**
 * 设置价格偏移
 * @param productCode 产品代码
 * @param offsetValue 偏移值
 */
export const setOffset = (productCode: string, offsetValue: number): Promise<PriceOffset> => {
  return request.post('/market/api/v1/admin/market/price/offset', {
    productCode,
    offsetValue
  });
};

/**
 * 删除价格偏移记录
 * @param id 价格偏移ID
 */
export const deleteOffset = (id: number): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/price/offset/${id}`);
};

/**
 * 取消价格偏移
 * @param productCode 产品代码
 */
export const cancelOffset = (productCode: string): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/price/offset/${productCode}`);
};

/**
 * 实时价格响应接口
 */
export interface RealTimePrice {
  productCode: string;
  controlPrice: number;
  price: number;
  volume: number;
  turnover: number;
  timestamp: number;
}

/**
 * 获取产品实时价格
 * @param productCode 产品代码
 */
export const fetchRealTimePrice = (productCode: string): Promise<RealTimePrice> => {
  return request.get(`/market/api/v1/admin/market/price/real-time/${productCode}`);
};

/**
 * 获取所有价格偏移记录（包括历史）
 */
export const fetchAllOffsets = (): Promise<PriceOffsetWithPointCount[]> => {
  return request.get('/market/api/v1/admin/market/price/offset/all');
};

/**
 * 取消价格偏移激活状态（保留数据）
 * @param productCode 产品代码
 */
export const deactivateOffset = (productCode: string): Promise<string> => {
  return request.put(`/market/api/v1/admin/market/price/offset/${productCode}/deactivate`);
};

/**
 * 清空价格偏移关联的点数据
 * @param offsetId 价格偏移ID
 */
export const clearOffsetPoints = (offsetId: number): Promise<string> => {
  return request.delete(`/market/api/v1/admin/market/price/offset/${offsetId}/points`);
};

/**
 * 通过ID更新价格偏移量
 * @param id 价格偏移记录的ID
 * @param offsetValue 新的偏移量值
 */
export const updateOffsetById = (id: number, offsetValue: number): Promise<PriceOffset> => {
  return request.put(`/market/api/v1/admin/market/price/offset/${id}`, {
    offsetValue
  });
}; 